'use client';
import type React from 'react';
import { useApp } from '@/forApp/states/appState/appState';
import Button from '@/shared/Buttons/Button';
import styles from './styles.module.css';

interface AttenBannerProps {
  mainBanner:
    | {
        name: string;
        description?: string;
        image_path: string;
      }
    | null
    | undefined;
  visbleButton?: boolean;
}

const AttenBanner: React.FC<AttenBannerProps> = ({
  mainBanner,
  visbleButton = false,
}) => {
  const { addModal } = useApp();

  if (!mainBanner) {
    return null;
  }

  const handleConsultationClick = () => {
    addModal({
      name: 'ConsultationModal',
      title: 'Получить консультацию',
      from: '',
    });
  };

  const processedDescription = mainBanner.description || '';

  return (
    <div className={styles.banner}>
      <div className={styles.desc}>
        <h1 className={styles.title}>{mainBanner.name}</h1>
        <div
          className={styles.description}
          dangerouslySetInnerHTML={{ __html: processedDescription }}
        ></div>
        {visbleButton && (
          <div className={styles.buttonContainer}>
            <Button
              onClick={handleConsultationClick}
              text="Получить консультацию"
            />
          </div>
        )}
      </div>
      <div className={styles.image}>
        <img src={mainBanner.image_path} alt={mainBanner.name} />
      </div>
    </div>
  );
};

export default AttenBanner;
